<template>
  <b-modal
    ref="modal"
    id="attendees-modal"
    class="large-modal"
    title="BootstrapVue"
    size="lg"
    ok-title="Back"
    ok-only
  >
    <template #modal-header>
      <div class="upper">
        <label v-if="event">{{event.topic}}</label>
        <div class="new-title">
          Attendees ({{users.length}})
        </div>
      </div>
      <button
        class="close"
        @click="hide()"
      >
        ×
      </button>
    </template>

    <attendees-table 
      v-if="users && users.length" 
      :workshopId="event.id"  
      :users="users" 
      @refunded="hide"
      @withdrawn="hide" />

    <p v-else>There are no attendees yet.</p>
  </b-modal>
</template>

<script>
import AttendeesTable from '@/components/tables/AttendeesTable.vue';

export default {
  name: 'AttendeesModal',
  components: {
    AttendeesTable,
  },
  props: {
    event: {
      type: Object,
    },
  },
  data() {
    return {
      users: null,
    };
  },
  methods: {
    show(users) {
      this.users = users;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
#attendees-modal {
  .upper {
    display: block;
    position: relative;
    padding-right: 30px;
  }

  label {
    @include label;

    display: block;
    margin-bottom: 10px;
  }

  .date {
    font-size: 18px;
    color: rgba(white, 0.75);
  }

  .pills {
    margin-top: 20px;
  }

  .new-title {
    display: block;
    color: white;
    font-size: 30px;
    font-weight: 700;
    font-family: "Playfair Display", serif;
    line-height: 1;
  }

  .description {
    opacity: 0.6;
  }

  h6 {
    font-weight: normal !important;
    font-size: 25px;
    margin-top: 30px;
    margin-bottom: 10px;

    span {
      font-weight: bold !important;
    }
  }

  .green {
    font-size: 13px;
    color: $green;
  }

  .avatars {
    margin-top: 20px;

    .user-avatar {
      @include background-cover;
      @include border-radius(100px);

      background-image: url('~@/assets/img/default-user.jpg');
      display: inline-block;
      height: 60px;
      width: 60px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }

  .text-btn {
    @include label;

    border: none;
    background: none;
    color: $green;
    padding: 0;
    outline: none;
    height: auto;
    font-weight: normal;
    margin-top: 25px;
    text-align: right;
    text-transform: none;
    opacity: 0.5;

    &:hover,
    &:focus {
      opacity: 1;
      text-decoration: underline;
    }
  }
}
</style>
